import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { DataGridComponent } from '../../../Common/Components/data-grid/data-grid.component';
import { ApiService } from '../../../Services/api.service';
import { SpinnerComponent } from '../../../Common/Components/spinner/spinner.component';

@Component({
  selector: 'app-associated-products',
  standalone: true,
  imports: [DataGridComponent, SpinnerComponent],
  templateUrl: './associated-products.component.html',
  styleUrl: './associated-products.component.scss'
})
export class AssociatedProductsComponent implements AfterViewInit {

  constructor(private apiService: ApiService) {

  }

  nestedParentColumns: any[] = [
    { field: '', header: '', type: 'expand' },
    { field: 'catalogName', header: 'Catalog Name' },
    { field: 'totalProducts', header: 'No of Products' }
  ];

  nestedChildColumns: any[] = [
    { field: 'productCategory', header: 'Product Category' },
    { field: 'productName', header: 'Product Name' }
  ];
  associateCatalogList: any = [];
  listOfParentData: any = [];
  @Input() selectedProdctId: any;
  @Input() selectedVersion: any;
  dataLoaded: boolean = false;
  @Output() emitParentData = new EventEmitter();

  ngAfterViewInit() {

    if (this.selectedProdctId || this.selectedVersion) {
      if (this.selectedProdctId || this.selectedVersion) {
        this.dataLoaded = false;

        this.apiService.associatedCatalogDetails(this.selectedProdctId, this.selectedVersion).subscribe(
          (res) => {
            this.associateCatalogList = res;

            this.associateCatalogList = this.associateCatalogList.map((node: any) => ({
              ...node,
              categoryStatus: node.deleteInd === 1 ? 'Inactive' : 'Active'
            }));

            this.transformCatalogData();

            this.dataLoaded = true;
          },
          (err) => {
            this.dataLoaded = true;
            this.apiService.createNotification('error', err.error?.message);
          }
        );
      }
    }


  }

transformCatalogData(): void {
  this.listOfParentData = [];
  const parentTracker = new Map<string, any>();
  let currentKey = 0;

  this.associateCatalogList.forEach((node: any) => {
    // 1. If the parent doesn't exist yet, create it
    if (!parentTracker.has(node.catalogName)) {
      const parentEntry = {
        key: currentKey++,
        catalogId: node.catalogId,
        catalogName: node.catalogName,
        expand: false, // <-- Change default to false initially
        catalogStatus: node.active === 1 ? 'Active' : 'Inactive',
        totalProducts: 0,
        children: []
      };

      parentTracker.set(node.catalogName, parentEntry);
      this.listOfParentData.push(parentEntry);
    }

    // 2. Fetch the parent (either newly created or existing)
    const matchingParent = parentTracker.get(node.catalogName);

    // 3. Add the child data and update the count immediately
    const sanitizedProductName = node.productName
      ? node.productName.replace(/&#39;/g, "'")
      : '';

    matchingParent.children.push({
      key: matchingParent.key,
      productCategory: node.productCategory,
      productName: sanitizedProductName,
    });

    matchingParent.totalProducts++;
  });


  if (this.listOfParentData.length === 1) {

    this.listOfParentData[0].expand = true;
    this.emitParentData.emit(false);
  } else {

    this.listOfParentData.forEach((parent: any) => {
      parent.expand = false;
    });
    this.emitParentData.emit(true);
  }
}


  collapseAllProducts(switchState: boolean): void {
    if (!this.listOfParentData || this.listOfParentData.length === 0) return;

    const targetState = !switchState;

    this.listOfParentData.forEach((parent: any) => {

      if (parent.expand !== targetState) {
        parent.expand = targetState;
      }
    });
  }



}
